export const loginPopupTypes = {
	SET_OPEN: 'SET_OPEN',
};

export const setLoginPopupOpen = (payload) => ({
	type: loginPopupTypes.SET_OPEN,
	payload,
});
